import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

interface EmailAddressFieldProps {
  disabled?: boolean;
  highlight?: boolean;
}
export function EmailAddressField({
  disabled,
  highlight = false,
}: EmailAddressFieldProps) {
  return (
    <FormFieldController
      name="email"
      rules={{
        required: 'Email address is required',
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: 'Invalid email address (Ex: me@example.com)',
        },
      }}
    >
      {({ field, fieldState }) => {
        return (
          <FormField
            label="Email address *"
            error={fieldState.error?.message?.toString()}
            type="email"
            highlight={highlight}
            inputProps={{
              id: 'email',
              placeholder: 'Email address',
              ...field,
              disabled,
            }}
          />
        );
      }}
    </FormFieldController>
  );
}
